"use strict";

var _objectWithoutProperties = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["children", "config", "className"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NFTFullPage = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var useMediaContext_1 = require("../context/useMediaContext");

var ProofAuthenticity_1 = require("./ProofAuthenticity");

var MediaFull_1 = require("./MediaFull");

var AuctionInfo_1 = require("./AuctionInfo");

var BidHistory_1 = require("./BidHistory");

var CreatorEquity_1 = require("./CreatorEquity");

var MediaInfo_1 = require("./MediaInfo");

var PlaceOfferButton_1 = require("./PlaceOfferButton");

var NFTProperties_1 = require("./NFTProperties");

var CollectionTag_1 = require("./CollectionTag");

var NFTDataProvider_1 = require("../context/NFTDataProvider");

var useA11yIdPrefix_1 = require("../utils/useA11yIdPrefix");

var NFTFullPage = function NFTFullPage(_ref) {
  var children = _ref.children,
      config = _ref.config,
      className = _ref.className,
      wrapperProps = _objectWithoutProperties(_ref, _excluded);

  var a11yIdPrefix = useA11yIdPrefix_1.useA11yIdPrefix("media");

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles,
      style = _useMediaContext_1$us.style;

  var allowOffer = config === null || config === void 0 ? void 0 : config.allowOffer;
  var showPerpetual = config === null || config === void 0 ? void 0 : config.showPerpetual;

  var getChildren = function getChildren() {
    if (children) {
      return children;
    }

    return jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, {
      children: [jsx_runtime_1.jsx(MediaFull_1.MediaFull, {
        a11yIdPrefix: a11yIdPrefix
      }, void 0), jsx_runtime_1.jsxs("div", Object.assign({}, getStyles("fullPageDataGrid"), {
        children: [style.theme.useCollectionTag && jsx_runtime_1.jsx(CollectionTag_1.CollectionTag, {}, void 0), jsx_runtime_1.jsx(MediaInfo_1.MediaInfo, {
          a11yIdPrefix: a11yIdPrefix
        }, void 0), jsx_runtime_1.jsx(NFTProperties_1.NFTProperties, {}, void 0), jsx_runtime_1.jsx(PlaceOfferButton_1.PlaceOfferButton, {
          allowOffer: allowOffer
        }, void 0), jsx_runtime_1.jsx(AuctionInfo_1.AuctionInfo, {
          showPerpetual: showPerpetual
        }, void 0), jsx_runtime_1.jsx(ProofAuthenticity_1.ProofAuthenticity, {}, void 0), jsx_runtime_1.jsx(BidHistory_1.BidHistory, {
          showPerpetual: showPerpetual
        }, void 0), jsx_runtime_1.jsx(CreatorEquity_1.CreatorEquity, {}, void 0)]
      }), void 0)]
    }, void 0);
  };

  return jsx_runtime_1.jsx(NFTDataProvider_1.NFTDataProvider, Object.assign({}, wrapperProps, {
    children: jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullPage", className), {
      children: getChildren()
    }), void 0)
  }), void 0);
};

exports.NFTFullPage = NFTFullPage;